<div class="cores-container">  
  <div class="colors-grid">
    <div class="color-item" *ngFor="let color of colors; let i = index">
      <div class="square-wrapper">
        <div 
          class="color-square" 
          [style.backgroundColor]="color.rgba"
          (click)="copyToClipboard(i)"
          title="Clique para copiar a cor (Ctrl+C)">
        </div>
        <button 
          class="delete-btn" 
          (click)="clearColor(i)"
          title="Limpar campos">
          <mat-icon>delete</mat-icon>
        </button>
        <button 
          class="picker-btn" 
          [matMenuTriggerFor]="colorMenu"
          (click)="openColorPicker(i)"
          title="Abrir seletor de cores">
          <mat-icon>search</mat-icon>
        </button>
      </div>
      <input 
        type="text" 
        class="hex-input" 
        placeholder="RGBA"
        [value]="color.hex"
        (input)="onHexInput(i, $event)"
        (blur)="onHexBlur(i)"
        maxlength="8">
      <input 
        type="text" 
        class="label-input" 
        placeholder="Nome da cor"
        [value]="color.label"
        (input)="onLabelInput(i, $event)">
    </div>
  </div>

  <mat-menu #colorMenu="matMenu" [overlapTrigger]="false" panelClass="color-picker-menu">
    <ng-template matMenuContent>
        <color-picker
          (click)="$event.stopPropagation()"
          [(value)]="activeColorValue"
          [(format)]="activeColorFormat"
          (valueChange)="onActiveColorChange($event)"
        ></color-picker>
    </ng-template>
  </mat-menu>
</div>
